export class OrderItem {
  constructor(data) {
    /** @type {number} */
    this.id = data.id;
    this.packageId = data.packageId;
    this.packageName = data.packageName;
    this.packageDescription = data.packageDescription;

    /** @type {boolean} Free Food Handler Card line added for a Premium Food Manager package. */
    this.isFreeFoodHandlerCard = data.isFreeFoodHandlerCard;
    this.price = data.price;
    this.quantity = data.quantity;
    this.isPaid = data.isPaid;
    this.paymentDate = data.paymentDate;
    this.expirationDate = data.expirationDate;
    this.discountCode = data.discountCode;
    this.discountCodeAmount = data.discountCodeAmount;
    this.discountCustomAmount = data.discountCustomAmount;
    this.orderId = data.orderId;
  }
}

export class BaseOrderItemCreation {
  constructor(data) {
    /** @type {number} */
    this.packageId = data.packageId;

    /** @type {number} */
    this.quantity = data.quantity;
  }
}

export class OrderItemCreation extends BaseOrderItemCreation {
  constructor(data) {
    super(data);

    /** @type {number} */
    this.discountCustomAmount = data.discountCustomAmount;

    /** @type {string | null} */
    this.discountCode = data.discountCode;

    /** @type {string | null} */
    this.rememberClassId = data.rememberClassId;

    /** @type {string | null} */
    this.rememberExamLanguageId = data.rememberExamLanguageId;
  }
}

export class OrderItemUpdate extends OrderItemCreation {}
